<template>
    <div class="error-wrapper">
        <div class="container">
            <Error500 />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const Error500 = defineAsyncComponent(() => import("@/components/theme/error/Error500.vue"))
</script>